import { Card, Grid, Space, Flex } from 'antd';
import React from 'react';
import { useTheme } from '../GlobalContext/ThemeContext';
import { ReactComponent as LogoWide } from '../../../Images/logo-wide.svg';
import { ReactComponent as LogoWideWhite } from '../../../Images/logo-wide-white.svg';
import Typography from 'antd/es/typography/Typography';
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher';
import { MoonOutlined, SunOutlined } from '@ant-design/icons';

const { useBreakpoint } = Grid;
const { Text } = Typography;

const CommonWrapper = ({ children }) => {
    const { isDarkMode, toggleDarkMode } = useTheme();
    const screens = useBreakpoint();

    return (
        <Flex
            vertical
            style={{
                minHeight: '100vh',
                height: '100vh',
                background: `url("https://www.transparenttextures.com/patterns/diamond-upholstery.png"), 
                    linear-gradient(to bottom, ${isDarkMode ? '#1f1f1f, #1f1f1f' : '#e3eef9, #2a588c'})`,
                padding: 0,
                margin: 0,
                overflow: 'hidden',
            }}
        >
            {/* Main content area */}
            <Flex 
                flex={1} 
                justify="center" 
                align="center"
                style={{
                    padding: screens.xs ? '10px 0' : 10,
                }}
            >
                <Card
                    style={{
                        width: '100%',
                        maxWidth: 400,
                        borderRadius: screens.xs ? 0 : 10,
                        boxShadow: screens.xs ? 'none' : '0 4px 10px rgba(0, 0, 0, 0.2)',
                        padding: 20,
                        margin: screens.xs ? 0 : '0 10px',
                        background: isDarkMode ? '#1f1f1f' : '#FFFFFF',
                    }}
                >
                    <div style={{ textAlign: 'center', marginBottom: 20 }}>
                        {!isDarkMode ? (
                            <LogoWide style={{ width: '100%' }} />
                        ) : (
                            <LogoWideWhite style={{ width: '100%' }} />
                        )}
                        <Text type="secondary" style={{ display: 'block', marginTop: 10 }}>
                            Log in to your account
                        </Text>
                    </div>
                    {children}
                </Card>
            </Flex>

            {/* Footer with language and dark mode controls - fixed at bottom */}
            <Flex
                justify="flex-end"
                style={{
                    width: '100%',
                    padding: '10px 20px',
                    boxSizing: 'border-box',
                }}
            >
                <Space>
                    <LanguageSwitcher />
                    <div
                        onClick={toggleDarkMode}
                        style={{
                            cursor: 'pointer',
                            fontSize: 20,
                            color: isDarkMode ? '#fff' : '#000',
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        {isDarkMode ? <MoonOutlined /> : <SunOutlined />}
                    </div>
                </Space>
            </Flex>
        </Flex>
    );
};

export default CommonWrapper;